import React from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";

const MultipleSelect = () => {
  return (
    <div className="col-md-12 my-3">
      <FloatingLabel controlId="textArea" label="Anahtar Kelime" />
      <Form.Control
        as="input"
        placeholder="Konu Başlığı"
        style={{ height: "50px" }}
      />
    </div>
  );
};

export default MultipleSelect;
